import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {EssType} from "../../interfaces/plant/EssType";
import apiV2 from "../../service/api/ApiV2";

interface essTypesState {
  data: EssType[];
  loading: boolean;
  error: string | null;
}

const initialState: essTypesState = {
  data: [],
  loading: false,
  error: null,
};

export const fetchEssTypes = createAsyncThunk("essTypes/fetchEssTypes", async () => {
  return apiV2.essTypes();
});

const essTypesSlice = createSlice({
  name: "essTypes",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEssTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEssTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchEssTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "An error occurred";
      });
  },
});

export default essTypesSlice.reducer;
